(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airconcare-film-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeAirconcareFilm(root) {
    root.querySelectorAll('.airconcare-film').forEach(function (section) {
      const video = section.querySelector('video');
      const sound = section.querySelector('.airconcare-film__sound');
      const pause = section.querySelector('.airconcare-film__pause');
      if (!video || !sound || !pause || video.dataset.airconcareReady) return;
      video.dataset.airconcareReady = 'true';

      function updatePauseButton() {
        pause.setAttribute('aria-label', video.paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel);
        pause.querySelector('.airconcare-film__pause-icon').textContent = video.paused ? '▶' : 'Ⅱ';
      }

      video.addEventListener('pause', updatePauseButton);
      video.addEventListener('play', updatePauseButton);
      video.addEventListener('ended', function () {
        video.muted = true;
        video.loop = true;
        video.currentTime = 0;
        sound.setAttribute('aria-pressed', 'false');
        sound.querySelector('.airconcare-film__sound-label').textContent = sound.dataset.soundLabel;
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.play().catch(function () { updatePauseButton(); });
        }
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.autoplay = false;
        video.pause();
      }
      updatePauseButton();
    });
  }

  initializeAirconcareFilm(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeAirconcareFilm(event.target);
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.airconcare-film__sound, .airconcare-film__pause');
    if (!button) return;
    const section = button.closest('.airconcare-film');
    const video = section && section.querySelector('video');
    if (!video) return;
    if (button.classList.contains('airconcare-film__pause')) {
      if (video.paused) video.play().catch(function () {});
      else video.pause();
      return;
    }
    if (video.muted) {
      video.currentTime = 0;
      video.loop = false;
      video.muted = false;
      button.setAttribute('aria-pressed', 'true');
      button.querySelector('.airconcare-film__sound-label').textContent = button.dataset.muteLabel;
      video.play().catch(function () {});
    } else {
      video.muted = true;
      video.loop = true;
      button.setAttribute('aria-pressed', 'false');
      button.querySelector('.airconcare-film__sound-label').textContent = button.dataset.soundLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
